import { useEvent } from '@emerald-works/react-event-bus-client'
import { useConfirm } from 'material-ui-confirm'
import { BannerStatic } from '../components'
import { useState } from 'react'

export function useDeleteUser ({ onDeleteSuccess = (payload) => console.log(payload) }) {
  const confirm = useConfirm()
  const [loading, setLoading] = useState(false)
  const [adminRemoveUser] = useEvent([{
    eventName: 'adminRemoveUser',
    onSuccess: (payload) => {
      if (payload.warning) BannerStatic.show({ label: payload.warning, isWarning: true })
      else BannerStatic.show({ label: 'User was successfully deleted.' })

      onDeleteSuccess && onDeleteSuccess(payload)
      setLoading(false)
    },
    onError: (err) => {
      BannerStatic.show({ label: 'An unexpected error ocurred while deleting the user.', isError: true })
      console.log('Error deleting user', err)
      setLoading(false)
    }
  }])

  async function deleteUser ({ username, tenantId }) {
    confirm({
      title: 'Delete user',
      description: 'This is a destructive action. Are you sure you want to delete this user?',
      confirmationText: 'Yes, delete it.',
      confirmationButtonProps: {
        id: 'delete-user-confirmation-button',
        'data-test': 'delete-user-confirmation-button'
      },
      cancellationText: 'No, thanks.',
      cancellationButtonProps: {
        id: 'delete-user-cancellation-button',
        'data-test': 'delete-user-cancellation-button'
      },
      dialogProps: {
        PaperProps: {
          id: 'delete-user-confirmation-modal',
          'data-test': 'delete-user-confirmation-modal'
        }
      },
      titleProps: {
        id: 'delete-user-confirmation-title',
        'data-test': 'delete-user-confirmation-title'
      }
    }).then(() => {
      setLoading(true)
      adminRemoveUser.trigger({ username, tenantId })
    }).catch(err => {
      console.log('Delete user cancelled', err)
    })
  }

  return {
    deleteUser,
    isDeleting: loading
  }
}
